/**
 * The BOM CSV rows and text (CONF-242). Extracted verbatim from
 * ExportToS3Dialog.jsx so the cell content is testable; the only behavioural
 * change is escapeCsvRow, which prefixes formula-leading cells (see
 * csvCellEscape.js). Column order is what the quote-explorer consumer reads —
 * bomCsv.test.js pins it.
 */
import Papa from 'papaparse';
import { escapeCsvRow } from './csvCellEscape';

export function buildBomCsvRows({ bom, config, preparedFor, currentDate, quoteNumber, quoteExpires }) {
  const filteredBom = bom.filter(item =>
    // Keep only items that have a partNumber (excludes empty rows and the total row)
    item.partNumber !== undefined
    && item.partNumber !== null
    && item.partNumber !== ''
    && item.showInCSV !== false
  );

  return filteredBom.map(item => escapeCsvRow({
    // 'Avnet Proposal#': '',  // Leave blank as it's system-generated
    // 'Customer Ref#': config.customerID,      // customerID is a legacy value that could be used in the future but for now it's supposed to be Opportunity ID
    'Quote Date': currentDate,
    'Opportunity ID': config.opportunityID || '',
    'Customer Name': preparedFor || '',
    'Partner Name': config.partnerName || '',
    'Prepared By': config.accountExecutive,
    'Email': config.accountExecutiveEmail,
    'Quote Number': quoteNumber,
    // 'Proposal Price': '' || '',            // Hiding from BOM export for now - could be a future field
    // 'Manufacturer': '',                    // Could be added to BOM data in future
    'Base Product Code': 'v5000',
    'Base Description': 'v5000',
    //'Item QTY': '1' || '',      // Removed for Clarity
    'Product Code': item.partNumber,
    'Parent Product Code': item.parentPartNumber,
    'List Price': parseFloat(item.list).toFixed(2) || '',
    'Discount Percentage': parseFloat(item.discount).toFixed(2) || '',
    'Discount Price': parseFloat(item.unitCost).toFixed(2) || '',
    // 'Discount': '0' || '',     // Removed for Clarity
    'Option QTY': item.quantity,
    'Month': item.months || '',
    'Extended Price': parseFloat(item.totalCost).toFixed(2) || '',
    // 'Option Group': '',
    'Option Description': item.item || '',
    'Quote Expires': quoteExpires,
    'Status': 'New'        // Default status for new proposals
  }));
}

export function buildBomCsv(args) {
  return Papa.unparse(buildBomCsvRows(args));
}
